<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="false" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"></ReturnNavBar>
            <div class="mobile_head_operate" >
                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                    <ul class="head_operate_popover_list">
                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                            <i :class="item.icon"></i> <span v-text="item.text"></span>
                        </li>
                    </ul>
                    <template #reference>
                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                    </template>
                </van-popover>
            </div>
        </div>
        <div class="warehouse_add_container mobile_container">
            <div class="warehouse_add_wrap">
                <div class="related_num" v-if="related_info && related_info.related_num">业务编号：<span v-text="related_info.related_num" class="link-label"  @click="handleClickRelatedDetail"></span></div>

                <div class="product_list">
                    <ul>
                        <li v-for="(item,index) in formData.productData" :key="index" :class="item.last ? 'last_li' : ''">
                            <div class="goods_info" v-if="pending_info && pending_info.biz_type == 'order' && item.first" >
                                <div v-if="item.goods_info">
                                    <div v-if="item.goods_info.goods_type == 'bundle'">
                                        <div class=" goods_name">
                                            <h5>
                                                {{item.goods_info.goods_name}}
                                                <span class="danger_text" v-text="item.goods_info.type == 1 ? '(销售)' : '(租借)'"></span>
                                            </h5>
                                            <span class="link-label" @click="item.expand = !item.expand">展开配置 <i class="iconfont icon-xiajiantou"></i></span>
                                        </div>
                                        <div class="goods_child_name" v-if="item.expand">
                                            <p  v-for="child in item.goods_info._child" v-text="child.goods_name"></p>
                                        </div>

                                    </div>
                                    <div v-else class="goods_name">
                                        <h5>{{item.goods_info.goods_name}} <span  class="danger_text"  v-text="item.goods_info.type == 1 ? '(销售)' : '(租借)'"></span></h5>
                                    </div>
                                </div>

                            </div>

                            <div class="product_field product_border flex_js_wrap">
                                <div class="product_name_wrap">
                                    <div class="product_name ellipsis" v-text="item.name"></div>
                                    <span class="audit_num ellipsis" v-text="item.audit_num + item.unit"></span>
                                </div>
                            </div>
                            <div class="product_field product_border">
                                <van-field @click="handleClickSelectStock(item)" clickable is-link label="" :value="item.stock_name"  name="stock_id"  placeholder="请选择出库仓库"  readonly></van-field>
                            </div>

                            <div class="product_field ">
                                <div class="bt required">出库数量/产品编码</div>
                                <div class="select_number flex_js_wrap">
                                    <van-field v-model="item.no_code_num" @change="handleChangeNum(item,index)" :disabled="item.stock_info.no_code_num > 0 ? false :true" type="" label="" placeholder="请输入数量"></van-field>
                                    <div class="select_code_box flex_js_wrap">
                                       <span>
                                            <span class="line"></span>
                                            <span class="select_btn" @click="handleClickSelectCode(item)" >选择编码</span>
                                       </span>
                                        <span class="total_num">共{{item.total_num}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                </div>

                <div class="field_item">
                    <div class="field_name">附件</div>
                    <div class="field_content">
                        <div class="file_list" v-if="formData.file_list && formData.file_list.length>0">
                            <ul>
                                <li v-for="(file, file_idx) in formData.file_list" :key="file_idx">
                                    <p class="ellipsis" v-text="file.file_name"></p>
                                    <div>
                                        <span @click="handleClickPreview(file)"><i class="iconfont icon-yanjing"></i></span>
                                        <span @click="formData.file_list.splice(file_idx,1)"><i class="iconfont icon-shanchu1"></i></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="file_note" v-else>支持.rar .zip .doc .docx .pdf .jpg...</div>
                        <div class="file_upload">
                            <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            <i class="iconfont icon-upload"></i>上传附件
                        </div>

                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">备注信息</div>
                    <div class="field_content">
                        <van-field
                                v-model="formData.note"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入备注信息"
                        />
                    </div>
                </div>

            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
        <SelectStock  :selectStockPopupShow.sync="selectStockPopupShow" v-if="selectStockPopupShow" :stockList="stockList" :selectedStockId="(productInfo && productInfo.stock_id) ? productInfo.stock_id : 0" @success="selectStockSuccess"/>
        <CodeIdentification :codeIdentificationPopupShow.sync="codeIdentificationPopupShow" v-if="codeIdentificationPopupShow" :sourceType="'out'" :productInfo="productInfo" :relatedType="pending_info.related_type" :related_info="related_info"  :selectedCodeData="selectedCodeData" :maxCodeIdentification="maxCodeIdentification" @success="identificationCodeSuccess" />
        <SelectCode  :selectCodePopupShow.sync="selectCodePopupShow" v-if="selectCodePopupShow"  :selectedCodeData="selectedCodeData" :productInfo="productInfo"  :relatedId="related_info.related_id" :stockType="pending_info.stock_type" :maxChangeNum="maxChangeNum"  @success="selectCodeOneSuccess" />

    </div>
</template>

<script>
import {Dialog, ImagePreview} from "vant";
import {chooseCode,pendingOutDetail,pendingOut,codeOutGetProduct,getStocksByProduct,getStocksAuth} from "@/api";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize,removeTag} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import SelectStock from "../component/select_stock"
import CodeIdentification from "../component/code_identification"
import SelectCode from "../component/select_code"
import {EventBus} from '@/utils/eventBus';
export default {
    name: "InWarehouseAudit",
    components: {ReturnNavBar,SelectStock,SelectCode,CodeIdentification},
    data() {
        return {
            loading:false,
            formData:{
                productData:[],
                file_list:[],
                note:''
            },
            btnDisabled:false,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:"codeIdentification", text: "粘贴编码识别", icon: "iconfont icon-chuku" },
                {value:"scan", text: "扫码出库", icon: "iconfont icon-saoyisao" },
                {value:"batch_stock", text: "批量选择仓库", icon: "iconfont icon-piliangcaozuo" },
            ],

            selectStockPopupShow:false,
            productInfo:null,
            codeIdentificationPopupShow:false,
            selectedCodeData:[],//已选编码



            related_info:null,
            pending_info:null,
            default_bring:['transfer_in','transfer_in_cancel'],
            selectCodePopupShow:false,
            maxCodeIdentification:null, //最大识别编码数量
            stockList:[], //可选的仓库
            maxChangeNum:0,//最多可选编码
        };
    },
    created() {
        this.stock_pending_id = this.$route.query.stock_pending_id
        if(this.stock_pending_id){
            this.getPendingOutDetail()
        }
    },
    methods: {
        // 获取详情
        getPendingOutDetail(){
            pendingOutDetail({ stock_pending_id:this.stock_pending_id }).then(res => {
                if (res.code === 200) {
                    let {related_info,product_list,pending_info,goods_list} = res.data
                    this.related_info = related_info
                    this.related_info.stock_pending_id = this.stock_pending_id
                    goods_list.forEach(item => {
                        item.goodsChildIds = []
                        if(item._child){
                            item.goodsChildIds = item._child.map(child => child.order_goods_id)
                        }
                        item.goodsChildIds.push(item.order_goods_id)
                    })

                    let productData = product_list.map(item => {
                        let goods_info = null
                        if(pending_info.biz_type == 'order'){
                            goods_info = goods_list.find(find => find.goodsChildIds.indexOf(item.related_detail_id) > -1)
                            let goods_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_id
                            let goods_sku_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_sku_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_sku_id
                            return {
                                goods_id,
                                goods_sku_id,
                                goods_info:goods_info,
                                name:item.product_name,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                related_detail_id:item.related_detail_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                stock_id:'',
                                audit_num:item.num,//待出库数量
                                audit_no_code_num:item.no_code_num,//可选的无编码数量
                                audit_code_num:item.code_num,//可选的有编码数量
                                no_code_num:'', //输入的无编码数量
                                code_num:0, //选择的有编码数量
                                code_list:[], //选择的编码
                                total_num:0, //选择的总数量
                                stock_list:[],
                                stock_info:{}
                            }
                        }else{
                            return {
                                name:item.product_name,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                related_detail_id:item.related_detail_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                stock_id:'',
                                audit_num:item.num,//待出库数量
                                audit_no_code_num:item.no_code_num,//可选的无编码数量
                                audit_code_num:item.code_num,//可选的有编码数量
                                no_code_num:'', //输入的无编码数量
                                code_num:0, //选择的有编码数量
                                code_list:[], //选择的编码
                                total_num:0, //选择的总数量
                                stock_list:[],
                                stock_info:{}
                            }
                        }
                    })

                    if(pending_info.biz_type == 'order') {
                        productData.sort((a, b) => {
                            return a.goods_id - b.goods_id; // 升序排序
                        });
                    }
                    // 这组数据相同goods_id的会挨着，需要用  js 把相同goods_id的第一个加一个first 字段 = true 最后一个加last = true   只有一个的话都加
                    let currentGoodsId = null;
                    let firstIndex = null;
                    for (let i = 0; i < productData.length; i++) {
                        const item = productData[i];
                        if (item.goods_id!== currentGoodsId) {
                            if (firstIndex!== null) {
                                productData[firstIndex].first = true;
                                productData[i - 1].last = true;
                            }
                            currentGoodsId = item.goods_id;
                            firstIndex = i;
                        }
                        if (i === productData.length - 1) {
                            productData[firstIndex].first = true;
                            productData[i].last = true;
                        }
                    }
                    this.formData.productData = productData
                    this.pending_info = pending_info
                    if(pending_info.biz_type == 'order'){
                        this.headOperateActionsList = [
                            {value:"batch_stock", text: "批量选择仓库", icon: "iconfont icon-piliangcaozuo" },
                        ]
                    }

                }
            })
        },
        // 头部+号操作
        handleClickHeadOperate(item){
            this.headOperatePopoverShow = false
            if(item.value == 'codeIdentification'){
                this.productInfo = null
                this.selectedCodeData = []
                this.formData.productData.forEach(item =>{
                    this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
                })
                this.codeIdentificationPopupShow = true
            }else if(item.value == 'batch_stock'){
                this.stockList = []
                this.productInfo = null
                this.selectStockPopupShow = true
            }
        },
        // 选择仓库
        handleClickSelectStock(item){
            if(item.name){
                let postData  = {
                    product_name:item.name,
                    sku_id:item.sku_id,
                    sku_key:item.sku_key,
                }
                getStocksByProduct(postData).then(res => {
                    if (res.code === 200) {
                        let data = res.data ? res.data.map((map)=>{
                            return {
                                id:map.stock_id,
                                name:map.stocks.name,
                                code_num:map.code_num,
                                no_code_num:map.no_code_num,
                                total_num:map.total_num,
                            }
                        }) : []
                        this.$set(item,'stock_list',data)
                        this.stockList = data
                        this.productInfo = item
                        this.selectStockPopupShow = true
                    }
                })
            }
        },
        // 选择仓库后回调
        selectStockSuccess(data){
            if(this.productInfo){
                this.handleClickClearStock(this.productInfo)
                let stock_info = this.productInfo.stock_list.find(find => find.id == data.id)
                if(stock_info){
                    this.$set(this.productInfo,'stock_info',stock_info)
                    this.$set(this.productInfo,'stock_id',stock_info.id)
                    this.$set(this.productInfo,'stock_name',stock_info.name)
                }

            }else{
                let postData = {
                    stock_id:data.id,
                    product_list:this.formData.productData.map((item)=>{
                        return {
                            product_name:item.name,
                            sku_id:item.sku_id,
                            sku_key:item.sku_key,
                        }
                    })
                }
                getStocksAuth(postData).then(res => {
                    if (res.code === 200) {
                       let dataInfo = res.data
                        this.formData.productData.forEach(item => {
                            let productItem = dataInfo.find(find => find.product_name == item.name && find.sku_id == item.sku_id && find.sku_key == item.sku_key && find.total_num > 0)
                            let stock_auth = productItem?.stock_auth
                            if(stock_auth){
                                this.handleClickClearStock(item)
                                let stock_info = {
                                    id:data.id,
                                    name:data.name,
                                    no_code_num:productItem.no_code_num,
                                    code_num:productItem.code_num,
                                    total_num:productItem.total_num,
                                }
                                this.$set(item,'stock_info',stock_info)
                                this.$set(item,'stock_id',stock_info.id)
                                this.$set(item,'stock_name',stock_info.name)
                                this.$set(item,'stock_list',[
                                    stock_info
                                ])
                            }
                        })
                    }
                })
            }
            this.productInfo = null
        },
        // 清除
        handleClickClearStock(row){
            this.$set(row,'code_num',0)
            this.$set(row,'code_list',[])
            this.$set(row,'no_code_num',0)
            this.$set(row,'total_num',0)
            this.$set(row,'stock_info',{code_num:0,no_code_num:0,total_num:0})
        },
        // 输入数量
        handleChangeNum(row,index){

            const num = row.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num) || !row.stock_id) {
                this.$set(row,'no_code_num',0)
            } else {
                // // 如果输入的数量大于  待办总数量 - 有编码的数量
                if(row.no_code_num > row.audit_num - row.code_num){
                    this.$set(row,'no_code_num',row.audit_num - row.code_num)
                }
                // 如果是采购退货 （采购入库过）则出库时得选择当时入过的，，
                if(this.pending_info.stock_type == 'purchase_return'){
                    // 如果输入的数量大于  当时入库时的无编码数量（待办无编码数量）
                    if(row.no_code_num >  row.audit_no_code_num){
                        let remaining =  row.no_code_num  - row.audit_no_code_num // 多余的数量
                        // 如果多余的数量大于 当时入库时的有编码数量 则取当时入库时的有编码数量  否则取多余的数量
                        remaining = remaining > row.audit_code_num ? row.audit_code_num : remaining
                        this.$set(row,'no_code_num',row.audit_no_code_num)
                        this.automatic_replenishment(row,remaining) //自动补充编码
                    }
                }else{

                    // 获取相同的产品
                    let identicalData = this.formData.productData.filter((filter,filterIndex) => filter.name == row.name && filter.sku_id == row.sku_id && filter.sku_key == row.sku_key && filter.stock_id == row.stock_id && filterIndex != index)
                    // 相同产品已使用的无编码总和（不包含自己）
                    const use_no_code_num = identicalData.map(item => item.no_code_num).reduce((a, b) => a + b, 0);
                    // 相同产品已使用的有编码总和（不包含自己）
                    const use_code_num = identicalData.map(item => item.code_num).reduce((a, b) => a + b, 0);
                    // 库存中还可以选择的无编码数量
                    let stock_no_code_num = row.stock_info.no_code_num - use_no_code_num
                    // 库存中还可以选择的有编码数量
                    let stock_code_num = row.stock_info.code_num - use_code_num

                    // 如果输入的无编码数量  大于 库存的无编码数量
                    if(row.no_code_num >  stock_no_code_num){
                        // 输入的无编码数量 -  库存的无编码数量 == 多余的数量
                        let remaining =  row.no_code_num  - stock_no_code_num
                        //如果多余的数量大于库存编码数量则自动补充的数量等于编码数量否则自动补充多余的数量
                        remaining = remaining > stock_code_num ? stock_code_num : remaining
                        this.automatic_replenishment(row,remaining) //自动补充编码
                        this.$set(row,'no_code_num',stock_no_code_num)
                    }

                }
            }
            this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
        },
        // 自动补充编码
        automatic_replenishment(row,remaining){

            // 相同的产品
            let identicalData = this.formData.productData.filter((filter) => filter.name == row.name && filter.sku_id == row.sku_id && filter.sku_key == row.sku_key && filter.stock_id == row.stock_id)
            let identicalProductCodeList =  []
            identicalData.forEach((item)=>{
                identicalProductCodeList = identicalProductCodeList.concat(item.code_list)
            }) //获取所有的相同产品已使用的编码
            let postData = {
                page: 1,
                pageSize: remaining + identicalProductCodeList.length, // 需要自动选择的编码+已经选择了的编码
                product_name:row.name,
                sku_id:row.sku_id,
                stock_id:row.stock_id,
                keyword: ''
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    // 创建一个包含 code 中现有的集合以便快速查找
                    const existingCodes = new Set(identicalProductCodeList.map(item => item.code));
                    // 过滤 list，获取不在 identicalProductCodeList 中的值 并且状态是正常的编码
                    const filteredList = list.filter(item => !existingCodes.has(item.code) && item.status == 0);
                    // 从过滤后的列表中添加 'remaining' 个到 code_list中
                    row.code_list.push(...filteredList.slice(0, remaining));
                    this.$set(row,'code_num',row.code_list.length)
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                    Dialog.alert({
                        title: '库存数量已自动补充',
                        message: '此产品无编码数量不足，已为您使用无编码与有编码组合，系统将自动选择有编码产品！',
                    });
                }else{

                }
            })
        },
        // 选择产品编码
        handleClickSelectCode(item){
            if(!item.name){ return this.$toast('请先选择产品')}
            if(!item.stock_id){return this.$toast('请先选择出库仓库')}
            this.productInfo = item
            this.selectedCodeData = []
            this.formData.productData.forEach(list =>{
                // 除了当前产品外其他已选的编码
                if(list.stock_pending_product_id != item.stock_pending_product_id){
                    this.selectedCodeData = this.selectedCodeData.concat(list.code_list)
                }
            })
            this.maxChangeNum = item.audit_num - item.no_code_num
            if(this.maxChangeNum == 0){
                return this.$toast('出库数量不可大于待出库数量')
            }
            this.selectCodePopupShow = true
        },
        // 选择编码后回调
        selectCodeOneSuccess(data){
            this.$set(this.productInfo,'code_list',data)
            this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
            this.$set(this.productInfo,'total_num',Number(this.productInfo.code_num) + Number(this.productInfo.no_code_num))
        },

        identificationCodeSuccess(data){
            this.loading = true
            let code_list = []
            this.formData.productData.forEach((item, key) => {
                let code = item.code_list.map(map => map.code)
                code_list = [...code_list, ...code]
            })
            let codeList = data.code_list.filter(item => !code_list.includes(item));
            if(codeList.length != data.code_list.length){
                this.$toast('检查到有重复的编码已经为您去重')
            }
            if(codeList.length == 0){
                this.loading = false;
                return  false
            }
            codeOutGetProduct({code_list:codeList}).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                        this.mergeProductFunction(item)
                    })
                }
                this.loading = false
            })
        },

        mergeProductFunction(row){
            let flag = true
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key){
                        if(item.stock_id == row.stock_id){
                            let code_list = row.code_list.map((map)=>{return {code:map}})
                            this.$set(item,'code_list',item.code_list.concat(code_list))
                            this.$set(item,'code_num',item.code_list.length)
                            this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                        }else if(item.stock_id == ''){
                            this.$set(item,'stock_list',row.stocks ? row.stocks : [])
                            if(item.stock_list.find(find => find.id == row.stock_id)){
                                this.$set(item,'stock_id',row.stock_id)
                                this.$set(item,'stock_name',item.stock_list.find(find => find.id == row.stock_id).name)
                                this.$set(item,'stock_info',item.stock_list.find(find => find.id == row.stock_id))
                                let code_list = row.code_list.map((map)=>{return {code:map}})
                                this.$set(item,'code_list',item.code_list.concat(code_list))
                                this.$set(item,'code_num',item.code_list.length)
                                this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                            }
                        }
                    }
                })
            }

        },

        // 关联查看详情
        handleClickRelatedDetail(){
            if(this.pending_info.related_type == 'purchase'){
                this.$router.push({
                    name:'purchaseDetail',
                    query:{
                        purchase_id:this.related_info.related_id
                    }
                })
            }else if(this.pending_info.biz_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:this.related_info.related_id,
                        name:this.related_info.related_num,
                    },
                });
            }
        },
        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },

        handleClickReturnRouter(){
            if (this.formData.note || this.formData.file_list.length > 0 || this.formData.productData.filter(item => (item.stock_id || item.total_num)).length>0 ){
                Dialog.confirm({
                    title: "取消",
                    message: "取消后，编辑内容不保留，是否取消！",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                })
                .then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                })
                .catch(() => { });
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },

        handleClickConfirm() {
            let flag = false
            let product_list = JSON.parse(JSON.stringify(this.formData.productData))
            let post_product_list = []
            product_list.forEach((item,index) => {
                delete item.audit_num
                delete item.stock_list
                delete item.stock_info
                item.no_code_num = item.no_code_num ? item.no_code_num : 0
                if(item.code_list && item.code_list.length>0){
                    this.$set(item, 'code_list', item.code_list.map(codeItem => codeItem.code));
                }
                if(item.total_num && !item.stock_id && !flag){
                    this.$toast(`请选择${item.name}出库仓库`)
                    flag = true
                }
                if(item.total_num){
                    post_product_list.push(item)
                }
            })
            if(flag){return  false}
            if(post_product_list.length == 0){return this.$toast('请至少出库一个产品')}
            let postData = {
                product_list:post_product_list,
                files:this.formData.file_list,
                note:this.formData.note,
                stock_pending_id:this.stock_pending_id,

                stock_type:this.pending_info.stock_type,
                approval_id:this.pending_info.approval_id,
                approval_uid:this.pending_info.uid,
                // approval_type:this.pending_info.approval_type,
                // approval_set_id:this.pending_info.approval_set_id,
                related_type:this.related_info.related_type,
                related_id:this.related_info.related_id,
                related_num:this.related_info.related_num,
            }
            Dialog.confirm({
                title: "提交出库",
                message: "确定执行出库操作吗？ \r\n 提交后无法撤回，请谨慎操作。",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            }).then(() => {
                this.btnDisabled = true
                pendingOut(postData).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            type: 'success',
                            message:'出库成功',
                            duration: 1500,
                            onClose: () => {
                                EventBus.$emit('inventoryOutUpdated');
                                removeTag(this.$route)
                                this.$router.go(-1);
                                this.btnDisabled = false
                            }
                        })
                    }else{
                        this.btnDisabled = false
                    }
                })
            }).catch(() => {
            })

        },

    },
};
</script>

<style lang="scss" scoped>
.warehouse_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .warehouse_add_wrap{
        background: #fff;
        .related_num{
            padding: 12px 16px 4px;
            box-sizing: border-box;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
        }
        .product_list{
            width: 100%;
            padding: 12px 16px;
            box-sizing: border-box;
            ul{
                li{
                    width: 100%;
                    margin-bottom: 10px;
                    border-radius: 6px;
                    background: rgba(247, 248, 250, 1);
                    &.last_li{
                        position: relative;
                        &:after{
                            content: '';
                            position: absolute;
                            left: -16px;
                            right: -16px;
                            bottom: -10px;
                            width: calc(100% + 32px);
                            height: 1px;
                            background: rgba(232, 232, 232, 1);
                        }
                    }
                    &:last-child{
                        margin-bottom: 0;
                        &:after{
                            display: none;
                        }
                    }
                    .goods_info{
                        width: 100%;
                        padding: 10px 0;
                        box-sizing: border-box;
                        background: #fff;
                        .goods_name{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            h5{
                                font-size: 16px;
                                color: rgba(51, 51, 51, 1);
                                line-height: 24px;
                                font-weight: bold;
                                max-width: calc(100% - 84px);
                                margin-right: 4px;
                            }
                            .danger_text{
                                color: rgb(228, 65, 68);
                            }
                            .link-label{
                                width: 80px;
                                font-size: 14px;
                            }
                        }
                        .goods_child_name{
                            width: 100%;
                            line-height: 18px;
                            font-size: 12px;
                            color: rgba(102, 102, 102, 1);
                            margin-top: 4px;
                        }
                    }

                    .product_field{
                        width: 100%;
                        padding: 0 12px;
                        .van-popover__wrapper{
                            flex: 1;
                            display: block;
                        }
                        &.product_border{
                            position: relative;
                            &:before{
                                position: absolute;
                                width: calc(100% - 24px);
                                height: 1px;
                                background: rgba(232, 232, 232, 1);
                                content: " ";
                                left: 12px;
                                bottom: 0;
                                z-index: 9;
                            }
                        }
                        .van-cell{
                            padding-left: 0;
                            padding-right: 0;
                            background: rgba(247, 248, 250, 1);
                        }
                        .field_button{
                            font-size: 14px;
                            padding-left: 8px;
                            color: rgba(41, 144, 255, 1);
                            line-height: 14px;
                            border-left: 1px solid rgba(232, 232, 232, 1);
                        }

                        .bt{
                            padding-top: 10px;
                            line-height: 22px;
                            font-size: 14px;
                            color: rgba(51, 51, 51, 1);
                            &.required{
                                position: relative;
                                padding-left: 6px;
                                &:before{
                                    position: absolute;
                                    left: 0;
                                    top: 10px;
                                    content: "*";
                                    color: rgba(228, 65, 68, 1);
                                }
                            }
                        }
                        .select_number{
                            width: 100%;
                            .van-cell{
                                width: 78px;
                            }
                            .select_code_box{
                                flex: 1;
                                line-height: 24px;
                                position: relative;
                                .select_btn{
                                    font-size: 14px;
                                    color: rgba(41, 144, 255, 1);
                                }
                                .total_num{
                                    border-radius: 4px;
                                    background: rgba(255, 255, 255, 1);
                                    min-width: 22px;
                                    padding: 0 4px;
                                    line-height: 22px;
                                    font-size: 14px;
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }

                        .product_name_wrap{
                            width: 100%;
                            padding: 10px 0;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            .product_name{
                                font-weight: bold;
                                font-size: 14px;
                                color: rgba(51, 51, 51, 1);
                                line-height: 22px;
                                max-width: calc(100% - 80px);
                            }
                            .audit_num{
                                height: 22px;
                                opacity: 1;
                                border-radius: 4px;
                                background: rgba(255, 255, 255, 1);
                                padding: 0 4px;
                                box-sizing: border-box;
                                font-weight: bold;
                                font-size: 14px;
                                color: rgba(51, 51, 51, 1);
                                line-height: 22px;
                            }
                        }


                    }
                }
            }
            .product_add{
                text-align: center;
                line-height: 22px;
                span{
                    color: rgba(25, 144, 255, 1);
                    i{
                        font-size: 14px;
                        margin-right: 8px;
                    }
                }
            }
        }

        .field_item{
            width: 100%;
            border-top: 1px solid rgba(247, 248, 250, 1);
            padding: 10px 16px;
            box-sizing: border-box;

            .field_name{
                width: 100%;
                line-height: 22px;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 4px;
            }
            .field_content{
                width: 100%;
                .van-cell{
                    padding:0 0 4px 0;
                }
                ::v-deep .van-cell--required::before{
                    position: initial;
                    margin-right: 2px;
                }
                .file_list{
                    width: 100%;
                    ul{
                        width: 100%;
                        li{
                            width: 100%;
                            margin-bottom: 10px;
                            border-radius: 2px;
                            background: rgba(249, 249, 249, 1);
                            border: 1px solid rgba(217, 217, 217, 1);
                            line-height: 20px;
                            padding: 0 8px;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                width: calc(100% - 50px);
                                font-size: 12px;
                                color: rgba(102, 102, 102, 1);
                            }
                            div{
                                width: 48px;
                                span{
                                    width: 16px;
                                    margin-left: 8px;
                                    text-align: center;
                                    line-height: 16px;
                                }
                                i{
                                    font-size: 14px;
                                    color: rgba(102, 102, 102, 1);
                                }
                            }
                        }
                    }
                }
                .file_note{
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                    line-height: 18px;
                    margin-bottom: 34px;
                }
                .file_upload{
                    width: 100px;
                    position: relative;
                    line-height: 22px;
                    margin: 0 auto;
                    color: rgba(25, 144, 255, 1);
                    font-size: 14px;
                    text-align: center;
                    i{
                        margin-right: 8px;
                    }
                    input{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                }

            }
        }
    }
}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}

::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow{
    display: none !important;
}

.productItemBox{
    width: calc(100vw - 56px);
    padding: 8px 2px;
    box-sizing: border-box;
    max-height: 220px;
    overflow-y: auto;
    .product_item{
        width: 100%;
        line-height: 30px;
        padding: 0 12px;
        color: rgba(102, 102, 102, 1);
        &:active{
            color: rgba(102, 102, 102, 1);
            background: rgba(0, 0, 0, 0.04);
        }
        .product_name {
            display: block;
            width: calc(100% - 50px);
        }
        .product_tag {
            width: 40px;
            height: 22px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(240, 170, 50, 0.1);
            line-height: 22px;
            font-size: 12px;
            color: rgba(240, 170, 50, 1);
            text-align: center;
        }
    }

}
</style>
